import React, { useContext } from 'react';
import { Typography, Box } from '@mui/material';
import DataExportsTable from './DataExportsTable';
import useDataExportGetByUser from '../hooks/useDataExportGetByUser';
import useUserInfo from '../hooks/useUserInfo';
import { AppContext } from '../../App';
import { useLocation } from 'react-router';
import { useSetTitle } from '../hooks/useSetTitle';
import TopBar from '../common/TopBar';
import RefreshButton from '../common/Buttons/RefreshButton';

const DataExportsWrapper = () => {
  useSetTitle(`Data Exports`);

  const { dataPoolLabel, dataPoolId } = useContext(AppContext);
  const userInfo = useUserInfo();

  const { search } = useLocation();

  const searchParams = new URLSearchParams(search);
  const perPage = Number(searchParams.get('perPage')) || 50;
  const page = Number(searchParams.get('page')) || 0;

  const {
    data: exportsAll,
    isLoading,
    isFetching,
    previousPage,
    nextPage,
    setPage,
    refetch,
  } = useDataExportGetByUser({
    userId: userInfo.data?.id,
    limit: perPage,
    defaultPage: page,
  });

  return (
    <div>
      <TopBar />

      <Box sx={{ backgroundColor: '#F5F6FA', padding: '20px 40px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Data Exports
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: '#65BBA9', fontWeight: 600 }}
            >
              {isLoading || isFetching ? '...' : (
                <>(<span data-cy="span-data-exports-count">{exportsAll?.count?.toLocaleString() || 0}</span>)</>
              )}
            </Typography>
          </Box>

          <RefreshButton
            cypressId="btn-manifest-export-refresh"
            disabled={isLoading || isFetching}
            isLoading={isLoading || isFetching}
            onClick={() => refetch()}
          />
        </Box>

        <DataExportsTable
          totalExports={exportsAll?.count || 0}
          exports={exportsAll?.results || []}
          loading={isLoading}
          isFetching={isFetching}
          previousPageDoc={previousPage}
          nextPageDoc={nextPage}
          page={page}
          perPage={perPage}
        />
      </Box>
    </div>
  );
};

export default DataExportsWrapper;
